import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ProjectList } from "../helpers/ProjectList";

function ProjectDisplay() {
  const { id } = useParams();
  const { hash } = useLocation();
  const project = ProjectList.filter(x => x.id === id)[0];

  // Open at the top of the page, or at a section when the link names one (/projects/LongShot#play).
  useEffect(() => {
    const target = hash && document.getElementById(hash.slice(1));
    if (target) {
      target.scrollIntoView();
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash])

  // Some projects have a page of their own instead of the standard layout below.
  if (project.page) {
    const Page = project.page;
    return <Page />;
  }

  return (
    <div className="projectDisplayItem w-full flex justify-center items-center flex-col dark:bg-[#3d4851] dark:text-[white]">
      <div className="projectDisplayItem inline-flex mt-8 mb-8 pr-4">
        <div className="inline-block pr-10">
          <h1 className="text-center pb-5 text-[black] dark:text-[white] text-4xl mt-4">{project.name}</h1>
          <img className="w-[100%] max-h-80 rounded-[10px] pl-6 mt-30" src={project.image} alt="project_image"/>
        </div>
        <div className="w-[100%] inline-block pl-1">
          <p className="text-2xl text-[black] dark:text-[white] pb-6">
            <b>Technology:</b> {project.technology}
          </p>
          <div className="text-2xl text-[black] dark:text-[white]">
            <p>
              <b>Description:</b> 
            </p>
            {project.description}
          </div>
        </div>
      </div>
      <div className="pt-4 pb-4">
        {project.external}
      </div>
      <div className="pb-4">
        {project.copyright}
      </div>
    </div>
  );
}

export default ProjectDisplay;
